module.exports = __webpack_public_path__ + "static/media/Steuart 3 750x774.9d56b1cb.png";